const GraphqlData = window.GraphqlData;

export const SpecialOffers = {
  // typeFilter: set by the Multi-Brand template to load model categories for its vehicle-type filter
  props: ["manufacturer", "allBrands", "lang", "graphqlEndpoint", "province", "typeFilter"],
  data() {
    return {
      offers: null,
      modalVisible: false,
      activeOffer: {},
      makes: [],
      modelImages: {},
      // Multi-Brand template: reactive brand filter ('all' or a make as it comes from the offers)
      activeMake: 'all',
      // Multi-Brand template: vehicle-type filter ('all' or a type key from vehicleTypes)
      activeType: 'all',
      // Multi-Brand template: offer shown on its own with the form panel (offerAnchor() id), or null for the list
      activeOfferId: null,
      // "make|model" (normalized) -> type keys, from Minerva's model list
      modelCategories: {},
      // Card highlighted after a hero tile or deal chip scrolls to it (offerAnchor() id)
      spotlightId: null,
      // Offer shown in the "Offer details" dialog (item.offers), or null when it's closed
      detailOffer: null,
    };
  },
  created() {
  },
  mounted() {
    this.bindOfferPanel();
    this.bindStickyOffset();

    GraphqlData.authenticateAndFetchData(null,'special-offers', null, null, this.graphqlEndpoint)
      .then((result) => {
        this.offers = result;
        let offersMakes = '';
        
        // Filter by manufacturer and other brands
        if(this.allBrands !== '')
          offersMakes = this.manufacturer.toLowerCase() + ',' + this.allBrands.toLowerCase();
        else
          offersMakes = this.manufacturer.toLowerCase();

        // LBT-1602: an offer with no make threw here and left this.offers unset,
        // which is the same permanent "Loading..." the null model produced in
        // template-special-offers.blade.php. Same defect, one step earlier.
        const filteredData = this.offers.filter(item => item.offers && item.offers.make && offersMakes.includes(item.offers.make.toLowerCase()));

        // Unique makes ignoring case: an offer typed as 'jeep' next to 'Jeep' is still one tab
        const seenMakes = {};
        this.makes = filteredData.map(item => item.offers.make).filter((make) => {
          const key = make.toLowerCase();
          if (seenMakes[key])
            return false;
          seenMakes[key] = true;
          return true;
        });
        this.offers = filteredData;

        // Order filtered data by make
        this.offers.sort((a, b) => (a.offers.make.toLowerCase() > b.offers.make.toLowerCase()) ? 1 : -1);
  
        // Filter by start date with format DD/MM/YYYY
        const today = new Date();
  
        const filteredDataByDateStart = this.offers.filter((item) => {
          if(item.offers.startDate == null)
            return true;
            
            // Convertir item.offers.startDate a un objeto de fecha
            const startDate = new Date(item.offers.startDate.split('/').reverse().join('-'));
            // Comparar las fechas
            return startDate <= today;
          
        });

        this.offers = filteredDataByDateStart;
  
        // Filter by end date with format DD/MM/YYYY
        const filteredDataByDate = this.offers.filter((item) => {
          if(item.offers.endDate == null)
            return true;
          
            // Convertir item.offers.endDate a un objeto de fecha
            const endDate = new Date(item.offers.endDate.split('/').reverse().join('-'));
            // Comparar las fechas
            return endDate >= today;
          
        });
  
        this.offers = filteredDataByDate;

        // Filter by province. Untagged offers always show.
        // Ford offers: QC dealers see QC offers, others see NATIONAL (unchanged).
        // Every other brand: offers tagged NATIONAL or the dealer's own province, so an Alberta dealer no
        // longer shows offers tagged BC only (Honda tags its offers by province).
        const dealerProvince = this.province ? this.province.toUpperCase() : '';

        this.offers = this.offers.filter((item) => {
          const provinces = (item.offers.province || []).map((value) => String(value).toUpperCase());

          if (!provinces.length)
            return true;

          if (item.offers.make.toLowerCase() === 'ford')
            return dealerProvince === 'QC' ? provinces.includes('QC') : provinces.includes('NATIONAL');

          // Without a province in the dealer contact settings there is nothing to match on
          if (!dealerProvince)
            return true;

          return provinces.includes('NATIONAL') || provinces.includes(dealerProvince);
        });

        this.offers.forEach((item, i) => {
          this.$set(this.activeOffer, i, 'lease');

          // The title and post ID sit next to offers, not in it; copy them in so helpers that only get item.offers
          // (anchors, the form panel) can name programs, which have no year/model/trim of their own
          if (item.offers && !item.offers.title)
            this.$set(item.offers, 'title', item.title);

          if (item.offers && item.databaseId)
            this.$set(item.offers, 'postId', item.databaseId);
        });

        this.loadModelImages();

        if (this.typeFilter)
          this.loadModelCategories();

        // Deep link: ?offer=ford-bronco-sport-<post ID> opens that offer's view straight away
        this.$nextTick(() => this.syncOfferFromUrl());
      })
      .catch((error) => {
        console.error("Error:", error.message);
      });
  },
  methods: {
    /* ---- Multi-Brand template helpers (template-special-offers-multibrand) ---- */
    // Any French locale reads French; every other one (en-CA, en-US) reads English
    isFrench() {
      return /^fr/i.test(this.lang || '');
    },
    t(en, fr) {
      return this.isFrench() ? (fr || en) : en;
    },
    // Minerva amounts are text ("1,519", or "11 500" when read from French copy). French puts the dollar sign after
    // the amount and spaces between thousands: "$1,519" / "1 519 $"
    money(amount) {
      return this.isFrench() ? `${this.amountText(amount)}\u00a0$` : `$${this.amountText(amount)}`;
    },
    // Just the number, for the big figures where the $ is its own element
    amountText(amount) {
      const value = String(amount == null ? '' : amount).replace(/\$/g, '').trim();

      if (!this.isFrench())
        return value;

      return value.replace(/,(?=\d{3}(?!\d))/g, ' ').replace(/\.(?=\d{1,2}$)/, ',').replace(/\s/g, '\u00a0');
    },
    // "4.49" / "4,49" for the big figures, "4.49%" / "4,49 %" in text
    rateText(rate) {
      return this.isFrench() ? String(rate).replace('.', ',') : String(rate);
    },
    percent(rate) {
      return this.isFrench() ? `${this.rateText(rate)}\u00a0%` : `${rate}%`;
    },
    offersForMake(make) {
      return (this.offers || []).filter((item) => item.offers.make.toLowerCase() === make.toLowerCase());
    },
    // Best deal first: payment offers by amount, then rate-only offers by rate, then cash/other offers
    sortedOffersForMake(make, applyType = true) {
      const rank = (offers) => {
        if (offers.payment)
          return [0, this.paymentAmount(offers.payment)];

        const type = this.primaryType(offers);

        if (type)
          return [1, type === 'lease' ? this.leaseRate(offers) : this.financeRate(offers)];

        return [2, 0];
      };

      // Single-offer view: only the opened offer is listed (the hero and other lists keep applyType = false)
      if (this.activeOfferId && applyType)
        return this.offersForMake(make).filter((item) => this.offerAnchor(item.offers) === this.activeOfferId);

      // Programs (notAVehicle) have their own section, so vehicle lists leave them out
      return this.offersForMake(make).filter((item) => !item.offers.notAVehicle && (!applyType || this.matchesType(item))).sort((a, b) => {
        const [groupA, valueA] = rank(a.offers);
        const [groupB, valueB] = rank(b.offers);

        return groupA - groupB || valueA - valueB;
      });
    },
    // Dealer's own manufacturer first, then the other brands in the order set in Leadbox settings
    orderedMakes() {
      const order = [this.manufacturer].concat((this.allBrands || '').split(','))
        .map((make) => make.trim().toLowerCase()).filter(Boolean);
      const position = (make) => {
        const index = order.indexOf(make.toLowerCase());

        return index === -1 ? order.length : index;
      };

      return this.makes.slice().sort((a, b) => position(a) - position(b));
    },
    // Makes rendered as sections: all of them, or only the selected one
    visibleMakes() {
      const opened = this.openedOffer();

      if (opened)
        return opened.offers.notAVehicle ? [] : [opened.offers.make];

      const makes = this.activeMake === 'all' ? this.orderedMakes() : this.orderedMakes().filter((make) => make === this.activeMake);

      // A brand with nothing of the selected type drops out instead of showing an empty section
      return makes.filter((make) => this.sortedOffersForMake(make).length > 0);
    },
    // Lowest payments across every brand, for the quick-deal chips in the hero
    heroDeals(limit = 5) {
      return (this.offers || []).filter((item) => item.offers.payment && !item.offers.notAVehicle)
        .sort((a, b) => this.paymentAmount(a.offers.payment) - this.paymentAmount(b.offers.payment))
        .slice(0, limit);
    },
    offerAnchor(offers) {
      // Programs share make/model ("Range Rover" loyalty and new-owner offers), so they're keyed by title.
      // The post ID keeps apart two offers on the same model and trim (two 2026 Charger Scat Pack offers).
      const parts = offers.notAVehicle ? [offers.make, this.decodedTitle({ title: offers.title })] : [offers.make, offers.model, offers.trim];

      return 'offer-' + parts.concat(offers.postId).filter(Boolean).join('-')
        .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    },
    scrollToOffer(offers) {
      this.activeMake = 'all';
      this.activeType = 'all';

      this.$nextTick(() => {
        const id = this.offerAnchor(offers);
        const target = document.getElementById(id);

        if (!target)
          return;

        this.revealCard(target, 'smooth');
        this.spotlightOffer(id);
      });
    },
    // Scroll a card into the space left below the fixed header and the sticky filters: centred there when it fits, top-aligned otherwise
    revealCard(card, behavior = 'auto') {
      const bar = this.$el.querySelector('.so-multibrand-filters');
      const covered = (parseFloat(this.$el.style.getPropertyValue('--so-sticky-offset')) || 0) + (bar ? bar.offsetHeight : 0);
      const room = window.innerHeight - covered;
      const gap = card.offsetHeight < room ? (room - card.offsetHeight) / 2 : 16;

      window.scrollTo({ top: window.scrollY + card.getBoundingClientRect().top - covered - gap, behavior });
    },
    // The highlight starts once the smooth scroll settles, so the customer sees it on arrival
    spotlightOffer(id) {
      if (this.spotlightCancel)
        this.spotlightCancel();

      this.spotlightId = null;

      let settle = null;
      let maxWait = null;
      let done = null;
      const onScroll = () => {
        clearTimeout(settle);
        settle = setTimeout(start, 120);
      };
      const cancel = () => {
        window.removeEventListener('scroll', onScroll);
        clearTimeout(settle);
        clearTimeout(maxWait);
        clearTimeout(done);
      };
      const start = () => {
        cancel();
        this.spotlightId = id;
        done = setTimeout(() => { this.spotlightId = null; }, 2600);
      };

      this.spotlightCancel = cancel;
      window.addEventListener('scroll', onScroll, { passive: true });
      settle = setTimeout(start, 150);
      maxWait = setTimeout(start, 1500);
    },
    // Cash offers keep the amount inside the free text ("GET\n$11,000\nCASH PURCHASE CREDIT\n...");
    // pull it out so the card can show it as the headline figure
    cashOffer(offers) {
      const lines = (this.t(offers.normalOfferLine2, offers.normalOfferLine2Fr) || '')
        .split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
      const amountIndex = lines.findIndex((line) => /^(\$\s?[\d,.]+|\d[\d\s,.]*\$)$/.test(line));

      if (amountIndex === -1)
        return null;

      return {
        amount: lines[amountIndex].replace(/\$/g, '').trim(),
        label: lines[amountIndex + 1] || this.t(offers.normalOfferLine1, offers.normalOfferLine1Fr),
        note: lines.slice(amountIndex + 2).join(' '),
      };
    },
    // Headline for offers with no rate or payment: the first dollar amount in their text, with what it's for.
    // "GET UP TO $9,500 IN TOTAL INCENTIVES" -> Up to / $9,500 / In total incentives,
    // "Eligible military/frontline services get up to $5,700 in price adjustments" adds the eligibility as a note.
    cashHeadline(offers) {
      const strict = this.cashOffer(offers);

      if (strict)
        return { prefix: this.t('Get', 'Obtenez'), amount: strict.amount, caption: this.softCaps(strict.label), note: this.softCaps(strict.note) };

      // Parse the line that holds the amount; the other line becomes part of the note
      const lines = [this.t(offers.normalOfferLine1, offers.normalOfferLine1Fr), this.t(offers.normalOfferLine2, offers.normalOfferLine2Fr)]
        .map((line) => (line || '').replace(/﹩/g, '$').replace(/\s+/g, ' ').trim()).filter(Boolean);
      // French copy puts the dollar sign after the amount: "JUSQU'À 11 500 $ EN INCITATIFS TOTAUX"
      const patterns = [
        /(up to\s*|starting at\s*|jusqu'à\s*|à partir de\s*)?\$\s?(\d[\d,]*(?:\.\d+)?)\s*(.*)$/i,
        /(jusqu['’]à\s*|à partir de\s*)?(\d{1,3}(?: \d{3})*(?:,\d+)?) ?\$\s*(.*)$/i,
      ];
      const pattern = patterns.find((candidate) => lines.some((line) => candidate.test(line)));

      if (!pattern)
        return null;

      const lineIndex = lines.findIndex((line) => pattern.test(line));
      const text = lines[lineIndex];
      const match = text.match(pattern);
      const leadIn = /\b(get|obtenez|obtiennent|peuvent(?:\s+obtenir)?|obtenir)(\s+a)?\s*$/i;
      let otherLines = lines.filter((_, index) => index !== lineIndex).join(' ');
      // "...services get up to" / "$4,400 in price adjustments": the "up to" belongs to the amount on the next line
      const carried = match[1] ? null : otherLines.match(/(?:^|\s)(up to|starting at|jusqu['’]à|à partir de)\s*$/i);

      if (carried)
        otherLines = otherLines.slice(0, carried.index);

      otherLines = otherLines.replace(leadIn, '').trim();

      // Text before the amount minus the lead-in verb: "Eligible military/frontline services get" -> eligibility
      const before = text.slice(0, match.index).replace(/^cash\s+/i, '').replace(leadIn, '').trim();
      // Short caption ("in EV incentives"); everything after the first joining word goes to the note
      const [caption, ...rest] = match[3].split(/\.\s+|\s(?=(?:and|for|on|with|available|includes|when|limited|et|pour|sur|avec|incluant|lorsque)\b)/i);
      const prefixText = match[1] || (carried && carried[1]);
      const prefix = prefixText ? this.softCaps(prefixText.trim()) : this.t('Get', 'Obtenez');

      return {
        prefix: prefix.charAt(0).toUpperCase() + prefix.slice(1),
        amount: match[2],
        caption: this.softCaps((caption || '').replace(/[.:]$/, '')),
        // Eligibility before the amount ("Eligible military/frontline services") or details after it
        // Keep eligibility like "Eligible military/frontline services"; drop lone lead-ins like "Cash"
        note: this.softCaps([before.split(/\s+/).length >= 2 ? before : '', rest.join(' '), otherLines].filter(Boolean).join(' · ')),
      };
    },
    // ALL-CAPS feed text in sentence case, keeping acronyms ("CASH PURCHASE CREDIT" -> "Cash purchase credit")
    softCaps(text) {
      const value = (text || '').trim();

      if (!value || /[a-z]/.test(value))
        return value;

      const acronyms = ['EV', 'PHEV', 'HST', 'AWD', '4X4', 'HD', 'MSRP', 'SUV', 'GMC', 'RAM', 'CPO', 'QC'];
      const sentence = value.toLowerCase().replace(/\b[a-z0-9]+\b/g, (word) => (acronyms.includes(word.toUpperCase()) ? word.toUpperCase() : word));

      return sentence.charAt(0).toUpperCase() + sentence.slice(1);
    },
    // ALL-CAPS program titles in title case ("RANGE ROVER LOYALTY PROGRAM OFFERS" -> "Range Rover Loyalty Program Offers")
    softTitle(text) {
      const value = (text || '').trim();

      if (!value || /[a-z]/.test(value))
        return value;

      const small = ['a', 'an', 'and', 'or', 'of', 'the', 'for', 'on', 'to', 'in', 'de', 'des', 'du', 'la', 'le', 'et'];

      return value.toLowerCase().split(' ').map((word, index) => (index > 0 && small.includes(word) ? word : word.charAt(0).toUpperCase() + word.slice(1))).join(' ');
    },
    /* ---- Programs: offers flagged notAVehicle in Minerva (loyalty cash, new-owner incentives, seasonal promos).
       They apply across models, so they get their own "More ways to save" section instead of a vehicle card. ---- */
    programOffers() {
      const opened = this.openedOffer();

      if (opened)
        return opened.offers.notAVehicle ? [opened] : [];

      // Programs have no vehicle type: they show with "All types" only
      if (this.activeType !== 'all')
        return [];

      return this.orderedMakes()
        .filter((make) => this.activeMake === 'all' || make === this.activeMake)
        .reduce((list, make) => list.concat(this.offersForMake(make).filter((item) => item.offers.notAVehicle)), []);
    },
    // Title, "Up to $3,000" headline, kind of program, eligibility paragraph and one line per model
    programDetails(item) {
      const offers = item.offers;
      const title = this.softTitle(this.decodedTitle(item));
      const lines = [this.t(offers.normalOfferLine1, offers.normalOfferLine1Fr), this.t(offers.normalOfferLine2, offers.normalOfferLine2Fr)]
        .join('\n').replace(/﹩/g, '$').split(/\r?\n/)
        .map((line) => line.replace(/\s+/g, ' ').trim().replace(/^[-•]\s*/, '')).filter(Boolean);
      const items = [];
      const paragraph = [];

      lines.forEach((line) => {
        const match = line.match(/^\$\s?(\d[\d,]*)\s+(.*)$/) || line.match(/^(\d{1,3}(?: \d{3})*) ?\$\s+(.*)$/);

        if (match) {
          // "$2,000 Loyalty Cash offer now available on 2026 Range Rover P400" -> $2,000 · 2026 Range Rover P400
          const text = match[2].replace(/^.*?\b(?:offer now available on|available on|on a new|on select|on)\s+/i, '');

          items.push({ amount: match[1], text: this.softCaps(text) });
        } else {
          paragraph.push(this.softCaps(line));
        }
      });

      const amounts = items.map((entry) => this.paymentAmount(entry.amount));
      const fromText = amounts.length ? null : this.cashHeadline(offers);
      const highest = amounts.length ? items[amounts.indexOf(Math.max(...amounts))].amount : (fromText && fromText.amount);
      const kind = /loyal/i.test(title) ? this.t('Loyalty cash', 'Prime de fidélité')
        : (/new owner|nouveau propri/i.test(title) ? this.t("New owner's incentive", 'Incitatif nouveau propriétaire') : (fromText ? fromText.caption : ''));

      return {
        title,
        headline: highest ? { prefix: items.length > 1 ? this.t('Up to', "Jusqu'à") : (fromText ? fromText.prefix : ''), amount: highest } : null,
        kind,
        paragraph: paragraph.join(' '),
        items,
      };
    },
    // Long names (12+ characters, two words or more) go on two balanced lines, which lets them be set larger
    ghostLines(model) {
      const name = (model || '').trim();
      const words = name.split(/\s+/);
      const longest = (lines) => Math.max(...lines.map((line) => line.length));
      let best = [name];

      if (words.length < 2 || name.length < 12)
        return best;

      for (let i = 1; i < words.length; i++) {
        const lines = [words.slice(0, i).join(' '), words.slice(i).join(' ')];

        if (best.length === 1 || longest(lines) <= longest(best))
          best = lines;
      }

      return best;
    },
    // Sized to the longest line (--ghost-chars), so the name always fits across the card
    ghostStyle(model) {
      return { '--ghost-chars': Math.max(...this.ghostLines(model).map((line) => line.length), 1) };
    },
    // Leadbox DataLayer (lbx_ui_interaction). window.LBX only exists where the datalayer is enabled in
    // Leadbox Settings, so this is a no-op everywhere else.
    trackUi(payload) {
      try {
        if (window.LBX && window.LBX.track && window.LBX.track.uiInteraction)
          window.LBX.track.uiInteraction(payload);
      } catch (error) {
        // Tracking must never break the page
      }
    },
    selectMake(make, position = 'offer_filters') {
      this.activeMake = make;
      this.trackUi({ element_type: 'filter', element_name: 'offers_brand', element_action: 'select', element_text: make, element_position: position });

      // Drop a type the new brand has no offers in, so the grid never ends up empty
      if (this.activeType !== 'all' && !this.availableTypes().some((type) => type.key === this.activeType))
        this.activeType = 'all';
    },
    selectType(type) {
      this.activeType = type;
      this.trackUi({ element_type: 'filter', element_name: 'offers_vehicle_type', element_action: 'select', element_text: type, element_position: 'offer_filters' });
    },
    /* ---- Vehicle-type filter ---- */
    // Minerva category names differ by brand ("SUVs" vs "SUV & Crossover"); fold them into one key each.
    // Commercial is left out on purpose: it overlaps Trucks and Vans.
    normalizeCategory(category) {
      const value = String(category || '').trim().toLowerCase();

      if (/suv|crossover/.test(value))
        return 'suvs';

      if (/truck|pickup/.test(value))
        return 'trucks';

      if (/^cars?$|sedan|coupe|hatch/.test(value))
        return 'cars';

      if (/van/.test(value))
        return 'vans';

      if (/electric|^evs?$/.test(value))
        return 'electric';

      return null;
    },
    vehicleTypes() {
      return [
        { key: 'suvs', label: this.t('SUVs', 'VUS') },
        { key: 'trucks', label: this.t('Trucks', 'Camions') },
        { key: 'cars', label: this.t('Cars', 'Voitures') },
        { key: 'vans', label: this.t('Vans', 'Fourgonnettes') },
        { key: 'electric', label: this.t('Electric', 'Électriques') },
      ];
    },
    modelKey(make, model) {
      return `${make}|${model}`.toLowerCase().replace(/[^a-z0-9|]+/g, ' ').replace(/\s+/g, ' ').trim();
    },
    loadModelCategories() {
      if (!this.makes.length)
        return;

      GraphqlData.authenticateAndFetchData(this.makes, 'offer-model-categories', null, null, this.graphqlEndpoint)
        .then((result) => {
          if (!result)
            return;

          const categories = {};

          Object.keys(result).forEach((alias) => {
            const nodes = (result[alias] && result[alias].nodes) || [];

            nodes.forEach((node) => {
              const model = node.modelData;

              if (!model || !model.make || !model.model || !model.category)
                return;

              const raw = Array.isArray(model.category) ? model.category : String(model.category).split(',');
              const types = raw.map((category) => this.normalizeCategory(category)).filter(Boolean);
              const key = this.modelKey(model.make, model.model);

              categories[key] = [...new Set((categories[key] || []).concat(types))];
            });
          });

          this.modelCategories = categories;
        })
        .catch((error) => {
          console.error("Error:", error.message);
        });
    },
    // Exact make+model first; otherwise any model whose words contain the offer's words or the other way
    // round ("Sierra HD" -> "Sierra 2500 HD", "Corvette" -> "Corvette Z06"). Unmatched offers only show under All.
    offerTypes(offers) {
      if (!offers || !offers.make || !offers.model || offers.notAVehicle)
        return [];

      const key = this.modelKey(offers.make, offers.model);

      if (this.modelCategories[key])
        return this.modelCategories[key];

      const [make, model] = key.split('|');
      const words = model.split(' ');
      const types = new Set();

      Object.keys(this.modelCategories).forEach((candidate) => {
        const [candidateMake, candidateModel] = candidate.split('|');

        if (candidateMake !== make)
          return;

        const candidateWords = candidateModel.split(' ');

        if (words.every((word) => candidateWords.includes(word)) || candidateWords.every((word) => words.includes(word)))
          this.modelCategories[candidate].forEach((type) => types.add(type));
      });

      return [...types];
    },
    matchesType(item) {
      return this.activeType === 'all' || this.offerTypes(item.offers).includes(this.activeType);
    },
    // Offers for the selected brand(s), ignoring the type filter: what the type chips count against
    offersInBrandSelection() {
      return (this.offers || []).filter((item) => this.activeMake === 'all' || item.offers.make === this.activeMake);
    },
    // Types with at least one offer in the current brand selection, with counts
    availableTypes() {
      const offers = this.offersInBrandSelection();

      return this.vehicleTypes()
        .map((type) => Object.assign({}, type, { count: offers.filter((item) => this.offerTypes(item.offers).includes(type.key)).length }))
        .filter((type) => type.count > 0);
    },
    // Brand chip counts follow the selected type
    makeCount(make) {
      return this.offersForMake(make).filter((item) => this.matchesType(item)).length;
    },
    /* ---- end vehicle-type filter ---- */
    // A rate label with an empty APR means 0% in Minerva (same rule as the classic template and the legal modal):
    // e.g. F-150 "Finance at" + blank rate + "For up to 72 Months" is 0% for 72 months.
    rateValue(apr, label) {
      if (apr !== null && apr !== undefined && apr !== '')
        return Number(apr);

      return label ? 0 : null;
    },
    leaseRate(offers) {
      return this.rateValue(offers.leaseApr, offers.leaseLabel);
    },
    financeRate(offers) {
      return this.rateValue(offers.financeApr, offers.financeLabel);
    },
    // Lease leads when the offer has a lease rate or a payment, finance otherwise; cash-only offers have neither
    primaryType(offers) {
      if (offers.payment || this.leaseRate(offers) !== null)
        return 'lease';

      if (this.financeRate(offers) !== null)
        return 'finance';

      return null;
    },
    // "For 48 Months" / "Pour 48 mois" -> 48
    termMonths(disclaimer) {
      const match = disclaimer ? String(disclaimer).match(/\d+/) : null;

      return match ? match[0] : null;
    },
    offerTerm(offers) {
      return this.termMonths(this.primaryType(offers) === 'finance' ? offers.financeDisclaimer : offers.leaseDisclaimer);
    },
    // Minerva labels, with a generic French one when the offer has no French copy (most brands don't send it).
    // Ford keeps "Finance at" offers in the lease fields, so the label says which kind it is.
    rateLabel(offers) {
      const lease = this.primaryType(offers) === 'lease';
      const label = lease ? offers.leaseLabel : offers.financeLabel;
      const financing = !lease || /financ/i.test(label || '');

      return this.t(label || (lease ? 'Lease at' : 'Finance at'), (lease ? offers.leaseLabelFr : offers.financeLabelFr) || (financing ? 'Financement à' : 'Location à'));
    },
    downLabel(offers) {
      return this.t((offers.downPaymentLabel || '').trim() || 'Down', offers.downPaymentLabelFr || 'Mise de fonds');
    },
    // Frequency in a label or disclaimer: "Bi-weekly" -> "/bi-wk", "Weekly" -> "/wk", "Per Month for 48 Months" -> "/mo".
    // "For 48 Months" alone is a term, not a frequency, so it gives nothing.
    paymentUnit(text) {
      const value = (text || '').toLowerCase();

      if (/bi-?week|biweekly|aux 2 sem|bimensuel|aux deux sem/.test(value))
        return this.t('/bi-wk', '/aux 2 sem.');

      if (/week|hebdo|par semaine/.test(value))
        return this.t('/wk', '/sem.');

      if (/monthly|per month|\/mo\b|par mois|mensuel/.test(value))
        return this.t('/mo', '/mois');

      return '';
    },
    // Land Rover's payment label is "Lease for" and the frequency lives in the disclaimer ("Per Month for 48 Months")
    offerPaymentUnit(offers) {
      const disclaimer = this.primaryType(offers) === 'finance' ? offers.financeDisclaimer : offers.leaseDisclaimer;

      return this.paymentUnit(this.t(offers.paymentLabel, offers.paymentLabelFr)) || this.paymentUnit(disclaimer);
    },
    // "1,519" -> 1519, so payments with thousands separators sort and compare as numbers
    paymentAmount(value) {
      return Number(String(value || '').replace(/[^\d.]/g, '')) || 0;
    },
    // Free-text offers (incentives, cash): a short first line is the headline, long text reads as a paragraph,
    // and "- item" lines in the second field become a list
    offerTextBlocks(offers) {
      const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();
      const first = clean(this.t(offers.normalOfferLine1, offers.normalOfferLine1Fr));
      const second = (this.t(offers.normalOfferLine2, offers.normalOfferLine2Fr) || '').split(/\r?\n/)
        .map((line) => clean(line).replace(/^[-•]\s*/, '')).filter(Boolean);

      return {
        headline: first && first.length <= 28 ? first : '',
        paragraph: first && first.length > 28 ? first : '',
        items: second,
      };
    },
    // DD/MM/YYYY -> "Nov 3, 2026" (or "3 nov. 2026")
    formatOfferDate(value) {
      if (!value)
        return '';

      const [day, month, year] = value.split('/').map(Number);
      const date = new Date(year, month - 1, day);

      return date.toLocaleDateString(this.lang, { month: 'short', day: 'numeric', year: 'numeric' });
    },
    // Whole sentences live here rather than in Blade fragments, so French gets its own word order
    heroLede() {
      const count = (this.offers || []).length;
      const makes = this.orderedMakes().join(', ');
      const ends = this.offersEndDate();

      return this.t(`${count} current offers on ${makes}.`, `${count} offres en cours sur ${makes}.`)
        + (ends ? ' ' + this.t(`Offers end ${ends}.`, `Les offres se terminent le ${ends}.`) : '');
    },
    financeBadge(offers) {
      const rate = this.percent(this.financeRate(offers));

      return this.t(`Or ${rate} financing`, `Ou financement à ${rate}`);
    },
    financeCalloutParts(offers) {
      const rate = this.percent(this.financeRate(offers));
      const term = this.termMonths(offers.financeDisclaimer);

      return {
        lead: this.t(`Or choose ${rate} financing`, `Ou choisissez un financement à ${rate}`),
        rest: term ? this.t(`for up to ${term} months`, `jusqu'à ${term} mois`) : '',
      };
    },
    financeCallout(offers) {
      const { lead, rest } = this.financeCalloutParts(offers);

      return rest ? `${lead} ${rest}` : lead;
    },
    // Latest end date among the visible offers, for the hero line
    offersEndDate() {
      const dates = (this.offers || []).map((item) => item.offers.endDate).filter(Boolean)
        .map((value) => value.split('/').reverse().join('-')).sort();

      return dates.length ? this.formatOfferDate(dates[dates.length - 1].split('-').reverse().join('/')) : '';
    },
    // Lowest payment for a make, with its unit, for the hero brand tiles
    lowestPayment(make) {
      const withPayment = this.offersForMake(make).filter((item) => item.offers.payment);

      if (!withPayment.length)
        return null;

      const lowest = withPayment.reduce((min, item) => (this.paymentAmount(item.offers.payment) < this.paymentAmount(min.offers.payment) ? item : min));

      return { amount: lowest.offers.payment, unit: this.offerPaymentUnit(lowest.offers) };
    },
    lowestRate(make) {
      const rates = [];

      this.offersForMake(make).forEach((item) => {
        if (this.leaseRate(item.offers) !== null)
          rates.push(this.leaseRate(item.offers));

        if (this.financeRate(item.offers) !== null)
          rates.push(this.financeRate(item.offers));
      });

      return rates.length ? Math.min(...rates) : null;
    },
    // Image of the cheapest offer for a make, shown on its hero tile
    makeImage(make) {
      const items = this.offersForMake(make).filter((item) => this.offerImage(item.offers));

      if (!items.length)
        return null;

      const sorted = items.slice().sort((a, b) => (this.paymentAmount(a.offers.payment) || Infinity) - (this.paymentAmount(b.offers.payment) || Infinity));

      return this.offerImage(sorted[0].offers);
    },
    // Cutout = white or transparent corners (Ford/Honda campaign shots, GM PNGs). Shape doesn't tell:
    // Cadillac's 960x500 images are as wide as Ford's but are full photos.
    isCutout(image) {
      try {
        const size = 16;
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        canvas.width = size;
        canvas.height = size;
        context.drawImage(image, 0, 0, size, size);

        const corners = [[0, 0], [size - 1, 0], [0, size - 1], [size - 1, size - 1]];
        const light = corners.filter(([x, y]) => {
          const [r, g, b, a] = context.getImageData(x, y, 1, 1).data;

          return a < 20 || (r > 235 && g > 235 && b > 235);
        });

        return light.length >= 3;
      } catch (error) {
        return false;
      }
    },
    // Cutouts are fitted instead of cropped and their white blended away; photos keep filling the box.
    // The pixels are read from a separate CORS copy: Minerva sends Access-Control-Allow-Origin on some
    // files (.png) but not others (.avif), and a crossorigin attribute on the visible image would block those.
    // If the copy is refused, the image simply stays a photo.
    imageLoaded(event) {
      const image = event.target;
      const box = image.parentElement;

      image.classList.add('is-loaded');

      if (!box)
        return;

      const probe = new Image();

      probe.crossOrigin = 'anonymous';
      probe.onload = () => box.classList.toggle('is-cutout', this.isCutout(probe));
      probe.onerror = () => box.classList.remove('is-cutout');
      probe.src = image.currentSrc || image.src;
    },
    // Single-brand dealers: the hero shows their best offers instead of one lone brand tile
    // One tile per model: Honda lists several trims of the same model (Civic Sedan LX, Civic Sedan Sport)
    heroFeatured(limit = 3) {
      const seen = {};

      return this.makes.length ? this.sortedOffersForMake(this.makes[0], false).filter((item) => {
        const key = this.modelKey(item.offers.make, item.offers.model);

        if (item.offers.notAVehicle || seen[key])
          return false;

        seen[key] = true;

        return true;
      }).slice(0, limit) : [];
    },
    // Rate offers can still carry free text, e.g. Ford's "Plus, get $750" / "In Loyalty Bonus for eligible owners"
    bonusLines(offers) {
      const cash = this.cashOffer(offers);

      // "CASH" / "GET A\n$10,000\nCASH PURCHASE CREDIT" next to a rate reads better as one sentence
      if (cash)
        return [this.t('Get', 'Obtenez') + ' ' + this.money(cash.amount), [cash.label, cash.note].filter(Boolean).join(' ').toLowerCase()];

      return [this.t(offers.normalOfferLine1, offers.normalOfferLine1Fr), this.t(offers.normalOfferLine2, offers.normalOfferLine2Fr)]
        .map((line) => (line || '').replace(/\s+/g, ' ').trim()).filter(Boolean);
    },
    scrollToOffers() {
      const target = document.querySelector('.so-multibrand-filters');

      if (target)
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    /* ---- Single-offer view with the "Get this offer" form (#so-offer-panel is rendered outside this component
       so Vue never touches the Ninja Forms markup and scripts; it gets moved into the view's panel slot) ---- */
    offerPanel() {
      return document.getElementById('so-offer-panel');
    },
    openedOffer() {
      return this.activeOfferId ? (this.offers || []).find((item) => this.offerAnchor(item.offers) === this.activeOfferId) || null : null;
    },
    // Headline deal in plain text: "$249/bi-wk lease · 60 months", "Finance at 0% APR for 72 months", "$10,000 cash purchase credit"
    offerDealText(offers) {
      const type = this.primaryType(offers);

      if (offers.notAVehicle) {
        const program = this.programDetails({ title: offers.title, offers });

        return program.headline ? [program.headline.prefix, this.money(program.headline.amount), program.kind.toLowerCase()].filter(Boolean).join(' ') : program.kind;
      }

      if (offers.payment) {
        const term = this.termMonths(type === 'finance' ? offers.financeDisclaimer : offers.leaseDisclaimer);

        const unit = this.offerPaymentUnit(offers);
        const termText = term ? ` · ${term} ${this.t('months', 'mois')}` : '';

        // French puts the type first: "location à 629 $/mois"
        return this.t(
          `${this.money(offers.payment)}${unit} ` + (type === 'finance' ? 'finance' : 'lease'),
          (type === 'finance' ? 'financement' : 'location') + ` à ${this.money(offers.payment)}${unit}`
        ) + termText;
      }

      if (type) {
        const rate = type === 'lease' ? this.leaseRate(offers) : this.financeRate(offers);
        const term = this.termMonths(type === 'lease' ? offers.leaseDisclaimer : offers.financeDisclaimer);

        return `${this.rateLabel(offers)} ${this.percent(rate)} ${this.t('APR', 'TAP')}` + (term ? ` ${this.t('for', 'pour')} ${term} ${this.t('months', 'mois')}` : '');
      }

      const cash = this.cashHeadline(offers);

      if (cash)
        return [cash.prefix, this.money(cash.amount), cash.caption.toLowerCase()].filter(Boolean).join(' ');

      return this.bonusLines(offers).join(' ');
    },
    // Extra lines after the deal: bonuses and the finance alternative
    offerNotes(offers) {
      const notes = [];

      if (this.primaryType(offers) && this.bonusLines(offers).length)
        notes.push(this.bonusLines(offers).join(' '));

      if (this.primaryType(offers) === 'lease' && this.financeRate(offers) !== null)
        notes.push(this.financeCallout(offers));

      return notes;
    },
    offerVehicleText(offers) {
      return offers.notAVehicle ? this.softTitle(this.decodedTitle({ title: offers.title })) : [offers.year, offers.make, offers.model, offers.trim].filter(Boolean).join(' ');
    },
    // What the dealer receives in the form's hidden "offer" field
    offerLeadText(offers) {
      const parts = [this.offerVehicleText(offers), this.offerDealText(offers)].concat(this.offerNotes(offers)).filter(Boolean);

      if (offers.endDate)
        parts.push(this.t('Offer ends', "Fin de l'offre") + ' ' + this.formatOfferDate(offers.endDate));

      return parts.join(' — ');
    },
    // Editable message, like the reference: "I'm interested in the 2026 Ford Bronco Sport offer: ... Please send me the details."
    offerMessageText(offers) {
      if (offers.notAVehicle)
        return this.t("I'd like to check my eligibility for the", "J'aimerais vérifier mon admissibilité au programme") + ` ${this.offerVehicleText(offers)}`
          + ` (${this.offerDealText(offers)}). ` + this.t('Please send me the details.', "Veuillez m'envoyer les détails.");

      return this.t("I'm interested in the", "Je suis intéressé(e) par l'offre sur le") + ` ${this.offerVehicleText(offers)}`
        + this.t(' offer: ', ' : ') + this.offerDealText(offers) + '. '
        + this.t('Please send me the details.', "Veuillez m'envoyer les détails.");
    },
    // Ninja Forms field model by key in the embedded Get Offer Information form
    offerFormField(formId, key) {
      if (!window.nfRadio)
        return null;

      const form = window.nfRadio.channel(`form-${formId}`).request('get:form');
      const fields = form && form.get('fields');

      return fields ? fields.findWhere({ key }) : null;
    },
    setOfferFormValue(formId, key, value, hide = false) {
      const field = this.offerFormField(formId, key);

      if (!field)
        return;

      field.set('value', value);

      const container = document.getElementById(`nf-field-${field.get('id')}-container`);

      if (!container)
        return;

      if (hide)
        container.classList.add('so-offer-panel__hidden-field');

      container.querySelectorAll('.nf-element').forEach((input) => { input.value = value; });
    },
    fillOfferPanel(offers) {
      const panel = this.offerPanel();
      const set = (selector, value) => {
        const element = panel.querySelector(selector);

        if (element)
          element.textContent = value || '';
      };

      set('[data-offer-title]', this.offerVehicleText(offers));
      set('[data-offer-deal]', this.offerDealText(offers));
      set('[data-offer-heading]', offers.notAVehicle
        ? this.t('Your eligibility details', 'Vérifiez votre admissibilité')
        : this.t(`Your ${offers.model} details`, `Les détails de votre ${offers.model}`));

      // Vehicle offers and programs promise different things
      panel.querySelectorAll('[data-benefits]').forEach((list) => {
        list.hidden = list.dataset.benefits !== (offers.notAVehicle ? 'program' : 'vehicle');
      });

      const image = panel.querySelector('[data-offer-image]');
      const src = this.offerImage(offers);

      if (image) {
        image.parentElement.classList.remove('is-cutout');
        image.classList.remove('is-loaded');
        image.hidden = !src;

        if (src) {
          image.onload = this.imageLoaded;
          image.src = src;
        }
      }

      const formId = panel.dataset.formId;
      const comments = this.offerFormField(formId, 'comments');
      const currentMessage = comments ? comments.get('value') : '';

      this.activeOfferLead = this.offerLeadText(offers);
      this.setOfferFormValue(formId, 'offer', this.activeOfferLead, true);

      // Pre-fill the message unless the customer already wrote their own
      if (comments && (!currentMessage || currentMessage === this.offerMessage)) {
        this.offerMessage = this.offerMessageText(offers);
        this.setOfferFormValue(formId, 'comments', this.offerMessage);
      }
    },
    // "Get this offer": open the offer on its own with the form. Without an embeddable form the link
    // keeps going to the form page (?vehicle=) as before.
    openOfferForm(offers, event, position = null) {
      const panel = this.offerPanel();

      if (!panel || !panel.dataset.formId)
        return;

      if (event)
        event.preventDefault();

      this.showOfferView(offers, true);
      this.trackUi({
        element_type: 'cta_button',
        element_name: offers.notAVehicle ? 'check_eligibility' : 'get_this_offer',
        element_action: 'click',
        element_text: this.offerVehicleText(offers),
        element_position: position || (offers.notAVehicle ? 'program_card' : 'offer_card'),
        element_url: window.location.href,
      });
    },
    showOfferView(offers, pushHistory) {
      const panel = this.offerPanel();
      const id = this.offerAnchor(offers);
      const alreadyOpen = this.activeOfferId === id;

      this.activeOfferId = id;
      this.fillOfferPanel(offers);

      if (pushHistory && !alreadyOpen) {
        const url = new URL(window.location.href);

        url.searchParams.set('offer', id.replace(/^offer-/, ''));
        url.hash = '';
        window.history.pushState({ soOffer: id }, '', url);
      }

      this.$nextTick(() => {
        const slot = this.$refs.offerPanelSlot;

        if (slot && panel.parentElement !== slot)
          slot.appendChild(panel);

        panel.hidden = false;

        // Phones stack the panel under the card: go straight to the form; larger screens show both
        const target = window.innerWidth < 768 ? panel : this.$el.querySelector('.so-multibrand-body');

        if (target)
          target.scrollIntoView({ behavior: alreadyOpen ? 'smooth' : 'auto', block: 'start' });

        const firstInput = [...panel.querySelectorAll('.nf-element')].find((input) => input.offsetParent !== null && !input.value);

        if (firstInput)
          setTimeout(() => firstInput.focus({ preventScroll: true }), 50);
      });
    },
    closeOfferView(pushHistory = true) {
      if (!this.activeOfferId)
        return;

      const id = this.activeOfferId;

      this.activeOfferId = null;

      // pushHistory means the customer clicked "All offers" / "Change"; browser back/forward passes false
      if (pushHistory) {
        const url = new URL(window.location.href);

        url.searchParams.delete('offer');
        window.history.pushState({}, '', url);
        this.trackUi({ element_type: 'cta_button', element_name: 'back_to_offers', element_action: 'click', element_text: id.replace(/^offer-/, ''), element_position: 'offer_view' });
      }

      // Back to the card the customer came from
      this.$nextTick(() => {
        const card = document.getElementById(id);

        if (card)
          this.revealCard(card);
      });
    },
    syncOfferFromUrl() {
      const slug = new URLSearchParams(window.location.search).get('offer');
      const item = slug ? (this.offers || []).find((offer) => this.offerAnchor(offer.offers) === 'offer-' + slug) : null;

      if (item && this.offerPanel())
        this.showOfferView(item.offers, false);
      else
        this.closeOfferView(false);
    },
    bindOfferPanel() {
      const panel = this.offerPanel();

      if (!panel)
        return;

      panel.querySelectorAll('[data-offer-close]').forEach((element) => element.addEventListener('click', () => this.closeOfferView()));

      // Browser back/forward between the list and an offer
      window.addEventListener('popstate', () => this.syncOfferFromUrl());

      // Ninja Forms submits its own field models: set the offer again right before submit
      const bindSubmit = () => {
        if (this.offerSubmitBound || !window.nfRadio)
          return;

        this.offerSubmitBound = true;
        window.nfRadio.channel('forms').on('before:submit', (formModel) => {
          if (String(formModel.get('id')) === String(panel.dataset.formId) && this.activeOfferLead)
            this.setOfferFormValue(panel.dataset.formId, 'offer', this.activeOfferLead, true);
        });
      };

      bindSubmit();
      jQuery(document).on('nfFormReady', () => {
        bindSubmit();

        // Hide the offer field as soon as the form renders
        const field = this.offerFormField(panel.dataset.formId, 'offer');
        const container = field && document.getElementById(`nf-field-${field.get('id')}-container`);

        if (container)
          container.classList.add('so-offer-panel__hidden-field');
      });
    },
    // A fixed site header (genius header.data.sticky renders header.lbsticky) covers the top of the viewport
    bindStickyOffset() {
      const header = document.querySelector('header.lbsticky');

      if (!header || !this.$el.classList || !this.$el.classList.contains('lbx-special-offers-multibrand'))
        return;

      const update = () => this.$el.style.setProperty('--so-sticky-offset', `${header.offsetHeight}px`);

      update();

      if (window.ResizeObserver)
        new ResizeObserver(update).observe(header);
      else
        window.addEventListener('resize', update, { passive: true });
    },
    openOfferDetails(offers, event) {
      this.detailOpener = event ? event.currentTarget : document.activeElement;
      this.detailOffer = offers;
      document.body.classList.add('overflow-hidden');

      // Opened from the keyboard (a click with detail 0), focus goes to the text so the arrows scroll it right away;
      // a mouse or tap focuses the dialog itself, so no focus ring shows around the text
      const target = event && event.detail === 0 ? 'offerDetailsBody' : 'offerDetails';

      this.$nextTick(() => {
        if (this.$refs[target])
          this.$refs[target].focus({ preventScroll: true });
      });
    },
    closeOfferDetails() {
      if (!this.detailOffer)
        return;

      this.detailOffer = null;
      document.body.classList.remove('overflow-hidden');

      if (this.detailOpener && document.body.contains(this.detailOpener))
        this.detailOpener.focus({ preventScroll: true });

      this.detailOpener = null;
    },
    // Esc closes and Tab stays inside the dialog. The datalayer reports the close button and the backdrop by
    // their classes; Esc is reported here so the open still gets its close.
    offerDetailsKeydown(event) {
      if (event.key === 'Escape') {
        this.closeOfferDetails();
        this.trackUi({ element_type: 'modal', element_name: 'detail_modal', element_action: 'close', element_text: null, element_position: null, element_url: null });

        return;
      }

      if (event.key !== 'Tab')
        return;

      const focusable = [...this.$refs.offerDetails.querySelectorAll('a[href], button, [tabindex="0"]')].filter((element) => element.offsetParent !== null);
      const index = focusable.indexOf(document.activeElement);

      if (event.shiftKey && index <= 0) {
        event.preventDefault();
        focusable[focusable.length - 1].focus();
      } else if (!event.shiftKey && index === focusable.length - 1) {
        event.preventDefault();
        focusable[0].focus();
      }
    },
    // Each word of the dialog title is kept whole, so "Mach-E" moves to the next line instead of breaking at the hyphen
    offerTitleWords(offers) {
      const title = offers.notAVehicle ? this.programDetails({ title: offers.title, offers }).title : offers.model;

      return String(title || '').trim().split(/\s+/);
    },
    getOfferFromDetails(event) {
      const offers = this.detailOffer;

      this.closeOfferDetails();
      this.openOfferForm(offers, event, 'offer_details');
    },
    // Legal text as paragraphs, the rate type's own text first. Minerva's "Offer Details" heading line is dropped
    // (the dialog has its own) and Ford's footnote numbers ("65 Weekly payment...") are split off to be set small.
    offerLegal(offers) {
      const lease = this.t(offers.legalEn, offers.legalFr);
      const finance = this.t(offers.financeLegalEn, offers.financeLegalFr);
      const texts = this.primaryType(offers) === 'finance' ? [finance, lease] : [lease, finance];

      return texts.filter(Boolean).join('\n\n').split(/\r?\n\s*\r?\n/)
        .map((block) => block.trim())
        .filter((block, index, blocks) => block && blocks.indexOf(block) === index && !/^(offer details|détails de l['’]offre)\s*:?$/i.test(block))
        .map((block) => {
          const footnote = block.match(/^(\d{1,3})\s+(?=[A-ZÀ-Ý])/);

          return footnote ? { mark: footnote[1], text: block.slice(footnote[0].length) } : { mark: '', text: block };
        });
    },
    /* ---- end Multi-Brand helpers ---- */
    changeActiveOffer(index, offerType){
      this.$set(this.activeOffer, index, offerType);
    },
    // Post title comes HTML-encoded from GraphQL; non-vehicle offers show it instead of year/model/trim
    decodedTitle(offer) {
      if (!offer || !offer.title)
        return '';

      const area = document.createElement('textarea');
      area.innerHTML = offer.title;

      return area.value;
    },
    // Image set on the offer itself in Minerva, falling back through the other sizes
    offerFieldImage(offers) {
      if (!offers)
        return null;

      const image = offers.desktopImage || offers.mainImage || offers.mobileImage;

      return image && image.sourceUrl ? image.sourceUrl : null;
    },
    // Image used by the templates: the offer's own image, or the model jellybean when it has none
    offerImage(offers) {
      const own = this.offerFieldImage(offers);

      if (own)
        return own;

      if (!offers || !offers.make || !offers.model)
        return null;

      const model = this.modelImages[`${offers.make}|${offers.model}`.toLowerCase()];

      if (!model)
        return null;

      // Same year when the model exists for it, newest one otherwise
      return model.years[offers.year] || model.latest || null;
    },
    // Fetched only when at least one offer has no image, so the usual case costs nothing
    loadModelImages() {
      const withoutImage = this.offers.filter((item) => !this.offerFieldImage(item.offers));

      if (!withoutImage.length)
        return;

      const makes = [...new Set(withoutImage.map((item) => item.offers.make).filter(Boolean))];

      if (!makes.length)
        return;

      GraphqlData.authenticateAndFetchData(makes, 'offer-model-images', null, null, this.graphqlEndpoint)
        .then((result) => {
          if (!result)
            return;

          const images = {};

          Object.keys(result).forEach((alias) => {
            const nodes = (result[alias] && result[alias].nodes) || [];

            nodes.forEach((node) => {
              const model = node.modelData;

              if (!model || !model.make || !model.model || !model.jellybean || !model.jellybean.sourceUrl)
                return;

              const key = `${model.make}|${model.model}`.toLowerCase();

              if (!images[key])
                images[key] = { years: {}, latest: null, latestYear: null };

              images[key].years[model.year] = model.jellybean.sourceUrl;

              if (images[key].latestYear === null || model.year > images[key].latestYear) {
                images[key].latestYear = model.year;
                images[key].latest = model.jellybean.sourceUrl;
              }
            });
          });

          this.modelImages = images;
        })
        .catch((error) => {
          console.error("Error:", error.message);
        });
    },
    show(make) {
      
      jQuery('.offers-brands span.offer-brand-item').each(function () {
        jQuery(this).removeClass(`offer-selected`);  
      });

      jQuery(`.${make.toLowerCase()}-offers`).addClass(`offer-selected`);  

      if(make && make !== 'all'){
        // Show all elements with class make-offer and hide others
        jQuery('.offer-cards div.offers').each(function(){
          // Show all elements with class make-offer
          if(jQuery(this).hasClass(`${make.toLowerCase()}-offer`)){
            jQuery(this).show();
          }
          else{
            jQuery(this).hide();
          }
        });
      }else{
        // Show all elements with class make-offer
        jQuery('.offer-cards div.offers').each(function(){
          jQuery(this).show();
        });
      }
    },
    hideModal(){
      jQuery('body').removeClass('overflow-hidden');
      this.modalVisible = false;
    },
    showItemInfo(item,offerType){
      if(item){
        let formattedLegalEn ='';
        let formattedLegalFr ='';
        let formattedFinanceLegalEn ='';
        let formattedFinanceLegalFr ='';

        if(item.legalEn)
          formattedLegalEn = item.legalEn.replace(/\r\n|\n/g, '<br>');
        
        if(item.legalFr)
          formattedLegalFr = item.legalFr.replace(/\r\n|\n/g, '<br>');

        if(item.financeLegalEn)
          formattedFinanceLegalEn += '<br>' + item.financeLegalEn.replace(/\r\n|\n/g, '<br>');

        if(item.financeLegalFr)
          formattedFinanceLegalFr += '<br>' + item.financeLegalFr.replace(/\r\n|\n/g, '<br>');
        
        setTimeout(() => {
          jQuery('body').addClass('overflow-hidden');
          if(offerType == 'lease'){
          jQuery('.lbx-bap-detail-modal__content').html(`
            <div class="flex flex-row flex-wrap justify-center lbx-bap-detail-modal__content__section">
              ${(!item.leaseApr && item.leaseLabel) || item.leaseApr ? `<h4 class="font-primary-bold flex text-center xl:text-left items-center justify-center w-full xl:w-1/3 lbx-bap-detail-modal__content_lease">${item.leaseApr ? item.leaseApr : 0}<span class="text-sm font-primary lbx-bap-detail-modal__content_lease-span">%</span> &nbsp;${(item.leaseDisclaimer ? (!this.isFrench() ? item.leaseDisclaimer : item.leaseDisclaimerFr) : '')}</h4>` : ''}
              ${item.downPayment ? `<h4 class="font-primary-bold flex text-center xl:text-left items-center justify-center w-full xl:w-1/3 lbx-bap-detail-modal__content_downpayment">${item.downPayment} ${!this.isFrench() ? item.downPaymentLabel : item.downPaymentLabelFr}</h4>` : ''}
              ${item.payment ? `<h4 class="font-primary-bold flex text-center xl:text-left items-center justify-center w-full xl:w-1/3 lbx-bap-detail-modal__content_payment">$${item.payment} ${(item.paymentDisclaimer ? (!this.isFrench() ? item.paymentDisclaimer : item.paymentDisclaimerFr) : '')}</h4>` : ''} 
            </div>
            <div class="flex flex-row gap-4 max-h-52 overflow-auto mt-2 lbx-bap-detail-modal__content_legal-section">
              <div class="w-full text-xs lbx-bap-detail-modal__content_legal-value">
              ${!this.isFrench() ? formattedLegalEn : formattedLegalFr}</div>
            </div>`
          );
          }else if(offerType == 'finance'){
            jQuery('.lbx-bap-detail-modal__content').html(`
            <div class="flex flex-row flex-wrap justify-center lbx-bap-detail-modal__content__section">
              ${(!item.financeApr && item.financeLabel) || item.financeApr ? `<h4 class="font-primary-bold flex text-center xl:text-left items-center justify-center w-full lbx-bap-detail-modal__content_finance">${item.financeApr ? item.financeApr : 0}<span class="text-sm font-primary lbx-bap-detail-modal__content_finance-span">%</span> &nbsp;${(item.financeDisclaimer ? (!this.isFrench() ? item.financeDisclaimer : item.financeDisclaimerFr) : '')}</h4>` : ''}
            </div>
            <div class="flex flex-row gap-4 max-h-52 overflow-auto mt-2 lbx-bap-detail-modal__content_legal-section">
              <div class="w-full text-xs lbx-bap-detail-modal__content_legal-value">
              ${!this.isFrench() ? formattedFinanceLegalEn : formattedFinanceLegalFr}</div>
            </div>`
          );
          }
        }, 10);
        
        this.modalVisible = true;
      }
    },
    loadingTemplate() {
      return `
      <div role="status" class="flex items-center justify-center">
        <svg aria-hidden="true" class="w-8 h-8 mr-2 text-gray-200 animate-spin"
          viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor" />
          <path class="text-primary fill-current"
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="none" />
        </svg>
      </div>
      <span class="flex items-center font-primary-bold justify-center loading-text">${
        !this.isFrench() ? "Loading" : "Chargement"
      }...</span>`;
    },
  },
};